"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePromptRecommendations = void 0;
var _react = require("react");
var _utils = require("@site/utils");
var _uuid = require("uuid");
var _useAddToCart = require("./useAddToCart");
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _utilities = require("../utilities");
var _constants = require("../constants");
// TODO: [USIDOM-1465] clean up cart functions to be handled via shared components

const usePromptRecommendations = (params = {}, searchInputRef) => {
  const [purchasedDomains, setPurchasedDomains] = (0, _react.useState)({});
  const [prompt, setPrompt] = (0, _react.useState)(null);
  const [handleAddDomainToCart, addToCardData, addToCartStatus] = (0, _useAddToCart.useAddToSapiCart)(params);
  const {
    eidPrefix = ''
  } = params;
  const setSearchInputFocus = () => {
    searchInputRef?.current?.focus();
  };
  const handlePromptSelect = ({
    venture,
    recommendations,
    title,
    description,
    promptId
  }) => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptButton,
      type: 'click',
      properties: {
        promptId
      }
    });
    setPrompt({
      venture,
      recommendations,
      title,
      description,
      promptId
    });
  };
  const getIsDomainPurchased = domainName => Boolean(purchasedDomains[domainName]);
  const handleExpressCartClose = status => {
    const {
      domainName
    } = addToCardData || {};
    handleAddDomainToCart.reset();
    if (status === _constants.REQUEST_STATUS.SUCCESS) {
      (0, _utils.logEvent)({
        eid: eidPrefix + _EidCodes.default.promptDomainPurchaseSuccess,
        type: 'view',
        properties: {
          promptId: prompt?.promptId
        }
      });
      setPurchasedDomains(currentPurchasedDomains => ({
        ...currentPurchasedDomains,
        [domainName]: true
      }));
      setPrompt(null);
      setSearchInputFocus();
      return;
    }
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptDomainPurchaseClose,
      type: 'click',
      properties: {
        promptId: prompt?.promptId
      }
    });
    setPrompt(null);
    setSearchInputFocus();
  };
  const handleExpressCartBack = () => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptDomainPurchaseBack,
      type: 'click',
      properties: {
        promptId: prompt?.promptId
      }
    });
    handleAddDomainToCart.reset();
  };
  const handleExpressCartError = () => {
    const {
      basketId
    } = addToCardData || {};
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptDomainPurchaseFailure,
      type: 'view',
      properties: {
        promptId: prompt?.promptId
      }
    });
    (0, _utilities.redirectToUrlWithDelay)((0, _utilities.getCartUrl)(params) + `?basketId=${basketId}`);
  };
  const handlePurchaseDomain = async ({
    product,
    domainName,
    isRestricted
  }, source) => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptAddToCart,
      type: 'click',
      properties: {
        source,
        isRestricted
      }
    });
    const [, onAddToCartStatus] = await handleAddDomainToCart({
      domainName,
      product,
      itc: _constants.SEARCH_RECOMMENDATION_ITC,
      basketId: isRestricted ? null : (0, _uuid.v4)()
    });
    if (onAddToCartStatus === _constants.REQUEST_STATUS.FAIL || onAddToCartStatus === _constants.REQUEST_STATUS.UNAVAILABLE) {
      (0, _utils.logEvent)({
        eid: eidPrefix + _EidCodes.default.promptAddToCartError,
        type: 'view',
        properties: {
          source,
          isRestricted
        }
      });
    } else {
      (0, _utils.logEvent)({
        eid: eidPrefix + _EidCodes.default.promptAddToCartSuccess,
        type: 'view',
        properties: {
          source,
          isRestricted
        }
      });
    }
    if (onAddToCartStatus === _constants.REQUEST_STATUS.SUCCESS && isRestricted) {
      (0, _utilities.redirectToUrlWithDelay)((0, _utilities.getDpxCartUrl)(params));
    }
    return onAddToCartStatus;
  };
  const handleDomainsModalBack = () => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptSuggestionsBack,
      type: 'click',
      properties: {
        promptId: prompt?.promptId
      }
    });
    setPrompt(null);
    setSearchInputFocus();
  };
  const handleDomainsModalClose = () => {
    (0, _utils.logEvent)({
      eid: eidPrefix + _EidCodes.default.promptSuggestionsClose,
      type: 'click',
      properties: {
        promptId: prompt?.promptId
      }
    });
    setPrompt(null);
    setSearchInputFocus();
  };
  return {
    prompt,
    purchasedDomains,
    handlePromptSelect,
    getIsDomainPurchased,
    handleExpressCartClose,
    handleExpressCartBack,
    handleExpressCartError,
    handlePurchaseDomain,
    handleDomainsModalBack,
    handleDomainsModalClose,
    addToCardData,
    addToCartStatus
  };
};
exports.usePromptRecommendations = usePromptRecommendations;